import { RDTillage } from '@cibo/core'
import { EventDetailEditorSimple } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { TillageEventEditorSimple } from './TillageEventEditorSimple'

export const TillageEditorSimple = ({
  fieldModels,
  year,
  name = 'tillageEditor',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => (
  <EventDetailEditorSimple<RDTillage['input']>
    traitId={traitId}
    fieldModels={fieldModels}
    year={year}
    name={name}
    requirement={requirement}
    filterInputs={filterInputs}
    EventComponent={TillageEventEditorSimple}
    translationContext="tillage"
    defaultEvent={{ date: null, implement: '' }}
    modal
  />
)
